import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: {"position":"relative","width":"100%","overflow":"hidden"},
    class: _normalizeClass(_ctx.src ? 'background_image':'background_no_image')
  }, [
    (_ctx.src)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "preview-window",
          style: {"position":"absolute","top":"50%","left":"50%","width":"auto","height":"auto","min-width":"100%","min-height":"100%","max-width":"inherit","transform":"translate(-50%, -50%)"},
          alt: "backgroundImage",
          src: _ctx.src
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 2))
}